import React from 'react';

function RowsPerPageSelector({ value, onChange }) {
  return (
    <div className="rows-per-page-container no-print" style={{display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.4rem 0.75rem', fontSize: '0.85rem'}}>
      <label style={{fontWeight: 500, color: 'var(--text-secondary)', whiteSpace: 'nowrap'}}>Rows per page:</label>
      <select 
        style={{border: 'none', background: 'transparent', fontWeight: 600, color: 'var(--primary-color)', cursor: 'pointer', padding: '0.2rem'}}
        value={value} 
        onChange={(e) => onChange(e.target.value === 'all' ? 'all' : parseInt(e.target.value))}
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value="all">All</option>
      </select>
    </div>
  );
}

export default RowsPerPageSelector;
